import styled from '@emotion/styled';
import { MymeType } from '@myme/utils';
import { HeartIcon, StarIcon } from 'src/icons';
import { mq } from 'src/themes/mediaQueries';
import { usePalette } from 'src/hooks';
import { HiddenChip } from './HiddenChip';
import { IconWithText } from './IconWithText';
import { MymeTypeIcon } from './MymeTypeIcon';
import { Price } from './Price';

interface Props {
  type: MymeType;
  isHidden?: boolean;
  likes: number;
  rating: number;
  price?: number | null;
}

const StyledBottomIcons = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;

  grid-area: bottomPanel;
  display: grid;
  align-items: center;
  grid-template-areas: 'likes rating price visibility mymeType';
  grid-template-columns: repeat(3, min-content) 1fr 2.5rem;
  margin-top: 1rem;

  ${mq.sm} {
    grid-template-columns: repeat(3, min-content) 1fr 1.75rem;
    margin: 0 -0.5rem;
    width: calc(100% + 1rem);
  }
`;

export const MymeBottomPanelContainer = ({ type, isHidden, likes, rating, price }: Props) => {
  const { error, warning } = usePalette();

  return (
    <StyledBottomIcons>
      <IconWithText name='likes' text={likes} icon={<HeartIcon fill={error.main} />} />
      <IconWithText name='rating' text={rating || '-'} icon={<StarIcon fill={warning.main} />} />
      {price ? <Price text={price} /> : null}
      {isHidden && <HiddenChip />}
      <MymeTypeIcon type={type} />
    </StyledBottomIcons>
  );
};
